import { createElement } from 'react';
import { hydrate } from 'react-dom';

const renderComponent = (module, props, el) => {
  const component = createElement(module.default, props);
  hydrate(component, el);
};

export default (el) => {
  const props = JSON.parse(el.dataset.props || '{}');

  if (process.env.NODE_ENV === 'production') {
    import(`javascripts/components/${el.dataset.component}`).then((module) => {
      renderComponent(module, props, el);
    });
  } else {
    import(
      /* webpackMode: "eager" */
      `javascripts/components/${el.dataset.component}`
    ).then((module) => {
      renderComponent(module, props, el);
    });
  }
};
